module.exports = __webpack_public_path__ + "static/media/poff_murray_bonfe.7e5c8ec8.png";